import React from 'react';
import { cn } from '../../shared/utils';

const VirtualTable = ({ data = [], columns = [], height = 500, rowHeight = 50, onRowClick, sort, dir, onSort }) => {
    return (
        <div className="border border-slate-200 rounded-lg overflow-hidden bg-white">
            {/* Header */}
            <div className="flex items-center bg-slate-100 border-b border-slate-200 font-bold text-slate-600 text-xs uppercase tracking-wider h-10">
                {columns.map((col, i) => {
                    // A column opts in by declaring sortKey; the rest stay plain text.
                    const sortable = !!(col.sortKey && onSort);
                    const active = sortable && sort === col.sortKey;
                    return (
                        <div key={i}
                            className={cn("px-4 flex items-center gap-1", col.className, sortable && "cursor-pointer select-none hover:text-slate-900")}
                            style={{ width: col.width }}
                            onClick={sortable ? () => onSort(col.sortKey) : undefined}
                            title={sortable ? 'Sort' : undefined}>
                            <span className={active ? 'text-purple-700' : undefined}>{col.header}</span>
                            {sortable && (
                                <span className={cn('text-[9px] leading-none', active ? 'text-purple-700' : 'text-slate-300')}>
                                    {active ? (dir === 'asc' ? '▲' : '▼') : '⇅'}
                                </span>
                            )}
                        </div>
                    );
                })}
            </div>

            {/* Simple List (No Virtualization) */}
            <div style={{ height, overflowY: 'auto' }}>
                {data.map((item, index) => (
                    <div
                        key={index}
                        className={cn(
                            "flex items-center border-b border-slate-100 hover:bg-slate-50 transition-colors cursor-pointer",
                            index % 2 === 0 ? "bg-white" : "bg-slate-50/50"
                        )}
                        style={{ height: rowHeight }}
                        onClick={(e) => onRowClick && onRowClick(item, e)}
                        onAuxClick={(e) => { if (e.button === 1 && onRowClick) { e.preventDefault(); onRowClick(item, e); } }}
                    >
                        {columns.map((col, i) => (
                            <div key={i} className={cn("px-4 py-2 text-sm truncate", col.className)} style={{ width: col.width }}>
                                {col.render ? col.render(item) : (item[col.key] !== undefined && item[col.key] !== null ? String(item[col.key]) : '')}
                            </div>
                        ))}
                    </div>
                ))}
                {data.length === 0 && (
                    <div className="p-4 text-center text-slate-500">No data available</div>
                )}
            </div>
        </div>
    );
};

export default VirtualTable;
